import React from 'react';
import css from './BookingSupport.module.css';
import IconCollection from '../IconCollection/IconCollection';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

const PAYMENT_LOGOS = ['stripeLogo', 'visaCard', 'masterCard'];

const BookingSupport = ({ variant, showPaymentLogos, titleClassName, descriptionClassName }) => {
    const items = [
        {
            icon: <IconCollection name="checkout_lock" />,
            titleId: 'CheckoutPage.secureBookingTitle',
            descriptionId: 'CheckoutPage.secureBookingDescription'
        },
        {
            icon: <IconCollection name="checkout_trust" />,
            titleId: 'CheckoutPage.trustedPaymentsTitle',
            descriptionId: 'CheckoutPage.trustedPaymentsDescription',
            logos: showPaymentLogos ? PAYMENT_LOGOS : null
        },
        {
            icon: <IconCollection name="checkout_support" />,
            titleId: 'CheckoutPage.realSupportTitle',
            descriptionId: 'CheckoutPage.realSupportDescription'
        }
    ];
    return (
        <div className={classNames(css.bookingSupport,variant === "lg" && css.bookingSupportLg)}>
            {items.map((item, idx) => (
                <div key={idx} className={css.item}>
                    <div className={css.topItem}>
                        {item.icon}
                        <div className={classNames(css.title, titleClassName)}>
                            <FormattedMessage id={item.titleId} />
                        </div>
                    </div>
                    {item.logos ? (
                        <div className={css.paymentLogos}>
                            {item.logos.map(logoName => (
                                <IconCollection key={logoName} name={logoName} />
                            ))}
                        </div>
                    ) : (
                        <p className={classNames(css.text, descriptionClassName)}>
                            <FormattedMessage id={item.descriptionId} />
                        </p>
                    )}
                </div>
            ))}
        </div>
    );
};

export default BookingSupport;